import React from "react";
import { useTranslation } from "react-i18next";
import { formatNumber } from "../../utils/functions";
import PrimaryButton from "canvas-core-react/lib/PrimaryButton";
import SecondaryButton from "canvas-core-react/lib/SecondaryButton";

const BillDetails = ({ goBack, onSubmit, data, admission }) => {
  if (!Object.keys(data).length) return null;

  const { t } = useTranslation();

  const { states, buttons } = {
    states: t("general.states", { returnObjects: true }),
    buttons: t("general.buttons", { returnObjects: true }),
  };

  const billData = formatData(data, states);

  return (
    <div className="bill-details my-5">
      {admission && (
        <h3 className="my-5">{t("report.billStatus.billUpdateTitle")}</h3>
      )}
      {Object.keys(details).map((key) => {
        const { title, ...rest } = t(`report.billStatus.itemDetails.${key}`, {
          returnObjects: true,
        });
        return (
          <div key={key} className="mt-4">
            <h3 className="mb-3">{title}</h3>
            <div className="d-flex flex-wrap justify-content-between">
              {details[key].map((name, index) => (
                <div className="input bill-status-width" key={`${key}-${name}`}>
                  <label
                    className={`label ${
                      name === "type" && admission ? "updated-info-color" : ""
                    }`}
                    htmlFor="clientReference"
                  >
                    {rest[`label${index + 1}`]}
                  </label>
                  <input
                    className="input input--text input--active"
                    type="text"
                    name="clientReference"
                    id="clientReference"
                    value={billData[key][name]}
                    disabled={true}
                  />
                </div>
              ))}
            </div>
          </div>
        );
      })}
      <div className="form-actions clearfix">
        <SecondaryButton
          id={`clear-btn`}
          className={`btnLimpiar`}
          onClick={goBack}
        >
          {buttons.back}
        </SecondaryButton>
        <SecondaryButton
          id={`accept-btn`}
          className={`btnAgregar`}
          onClick={admission ? () => onSubmit(false, data.id) : onSubmit}
        >
          {buttons[admission ? "rejected" : "accept"]}
        </SecondaryButton>
        {admission && (
          <PrimaryButton
            id={`accept-btn`}
            className={`btnAgregar`}
            onClick={() => onSubmit(true, data.id)}
          >
            {buttons["approve"]}
          </PrimaryButton>
        )}
      </div>
    </div>
  );
};

export default BillDetails;

const formatData = (
  {
    billNumber,
    company,
    type,
    dateOfIssue,
    expirationDate,
    provider,
    historyOfApprovals,
    totalAmount,
    currency,
    dateMaturity,
    detail,
    referenceNumberLoan,
    referenceNumber,
  },
  states
) => {
  const providerAccount = provider.provider?.accounts?.[0] || {};

  const findHistoryKey = (key, valueToMatch, value) => {
    return historyOfApprovals.find(({ [key]: ref }) => ref === valueToMatch)?.[
      value
    ];
  };

  const formatDate = (key, showHour) => {
    const date = findHistoryKey("status", key, "createDate");

    if (!date) return null;

    const formatDate = new Date(date);
    const hour = `/ ${formatDate.toLocaleString("en-US", {
      hour: "numeric",
      hour12: true,
      minute: "numeric",
    })}`;

    return `${getLongDate(formatDate)} ${showHour ? hour : ""}`;
  };

  const getLongDate = (date) => {
    return `${date.getUTCDate()}-${date.toLocaleString("es", {
      month: "long",
      minimumFractionDigits: 4,
    })}-${date.getUTCFullYear()}`;
  };

  const amount = formatNumber(totalAmount, "");

  const clientExpiration = dateMaturity
    ? new Date(dateMaturity).toLocaleDateString()
    : null;

  const getProviderExpiration = () => {
    if (!expirationDate) return null;
    const formatDate = new Date(expirationDate);
    return `${formatDate.getUTCDate()}-${formatDate.toLocaleString("es", {
      month: "long",
      minimumFractionDigits: 4,
    })}-${formatDate.getUTCFullYear()}`;
  };

  return {
    client: {
      name: company.companyName,
      refClient: referenceNumber,
      businessId: company.businessId,
      cif: company.cif,
      type: states[type],
      loadNumber: referenceNumberLoan,
      expirationDate: clientExpiration,
    },
    provider: {
      name: provider.companyName,
      businessId: provider.businessId,
      account: providerAccount.accountNumber,
      bicDestinationBank: providerAccount.bicDestinationBank,
      approvedUser: findHistoryKey("status", "APPROVED", "createBy"),
      acceptedUser: findHistoryKey("status", "ACCEPTED", "createBy"),
      expirationDate: getProviderExpiration(),
      acceptedDate: formatDate("APPROVED", true),
    },
    bill: {
      billNumber,
      totalAmount: amount,
      currency,
      approvedDate: formatDate("APPROVED", true),
      loadDate: formatDate("DRAFT", true),
      processedDate: formatDate("PROCESSED", true),
      emisionDate: dateOfIssue ? getLongDate(new Date(dateOfIssue)) : null,
      providerTotalAmount: amount,
      detail,
    },
  };
};

const details = {
  client: [
    "name",
    "refClient",
    "businessId",
    "cif",
    "type",
    "loadNumber",
    "expirationDate",
  ],
  provider: [
    "name",
    "businessId",
    "account",
    "bicDestinationBank",
    "approvedUser",
    "acceptedUser",
    "expirationDate",
    "acceptedDate",
  ],
  bill: [
    "billNumber",
    "totalAmount",
    "currency",
    "approvedDate",
    "loadDate",
    "processedDate",
    "emisionDate",
    "providerTotalAmount",
    "detail",
  ],
};
